module.exports = __webpack_public_path__ + "static/media/Roboto-Thin.4f0b85f5.ttf";